import request from "@/plugins/request";
import store from '@/store';
import base from '@/config/baseUrl';
import router from '@/router';
import {
	prompt,
	$alert
} from '@/plugins/utils';
//可以new多个request来支持多个域名请求
let $http = new request({
	//接口请求地址
	baseUrl: base.baseUrl,
	//服务器本地上传文件地址
	fileUrl: base.baseUrl,
	// 服务器上传图片默认url
	defaultUploadUrl: "",
	//设置请求头（如果使用报错跨域问题，可能是content-type请求类型和后台那边设置的不一致）
	header: {
		'Content-Type': 'application/json;charset=UTF-8',
		'project_token': base.projectToken, //项目token（可删除）
	}
});
// 添加获取七牛云token的方法
$http.getQnToken = function (callback) {
	//该地址需要开发者自行配置（每个后台的接口风格都不一样）
	$http.get("api/open/v1/qn_upload").then(data => {
		/*
		 *接口返回参数：
		 *visitPrefix:访问文件的域名
		 *token:七牛云上传token
		 *folderPath:上传的文件夹
		 *region: 地区 默认为：SCN
		 */
		callback({
			visitPrefix: data.visitPrefix,
			token: data.token,
			folderPath: data.folderPath
		});
	});
}
//请求开始拦截器
$http.requestStart = function (options) {
	console.log("请求开始", options);
	if (options.load) {
		//打开加载动画
		store.commit("setLoading", true);
	}
	// 图片上传大小限制
	if (options.method == "FILE" && options.maxSize) {
		// 文件最大字节: options.maxSize 可以在调用方法的时候加入参数
		let maxSize = options.maxSize;
		for (let item of options.files) {
			if (item.size > maxSize) {
				setTimeout(() => {
					prompt("图片过大，请重新上传");
				}, 500);
				return false;
			}
		}
	}
	if (store.state.currentCountry && store.state.currentCountry.servesCode) {
		options.header['language'] = store.state.currentCountry.servesCode;
	}
	//请求前加入token
	let user_token = localStorage.getItem("user_token") || sessionStorage.getItem("user_token");
	if (user_token) {
		options.header['user_token'] = user_token;
	}
	return options;
}
//请求结束
$http.requestEnd = function (options) {
	//判断当前接口是否需要加载动画
	if (options.load) {
		// 关闭加载动画
		store.commit("setLoading", false);
	}
}
let loginPopupNum = 0;
//所有接口数据处理（此方法需要开发者根据各自的接口返回类型修改，以下只是模板）
$http.dataFactory = async function (res) {
	console.log("接口请求数据", {
		url: res.url,
		resolve: res.response,
		header: res.header,
		data: res.data,
		method: res.method,
	});
	if (res.response.status && res.response.status == 200) {
		let httpData = res.response.response;
		if (typeof (httpData) == "string") {
			httpData = JSON.parse(httpData);
		}
		/*********以下只是模板(及共参考)，需要开发者根据各自的接口返回类型修改*********/
		//判断数据是否请求成功
		if (httpData.success || httpData.code == 0) {
			// 返回正确的结果(then接受数据)
			return Promise.resolve(httpData);
		} else if (httpData.code == "1000" || httpData.code == "1001" || httpData.code == 1000 || httpData.code == 402) {
			store.commit("emptyUserInfo");
			let content = '此时此刻需要您登录喔~';
			if (httpData.code == "1000") {
				content = '此时此刻需要您登录喔';
			}
			if (loginPopupNum <= 0) {
				loginPopupNum++;
				$alert(content, {
					type: 1,
					confirmText: "去登录",
					cancelText: "再逛会",
				}, function (res) {
					loginPopupNum--;
					if (res.confirm) {
						router.push('/login');
					}
				});
			}
			// #endif
			// 返回错误的结果(catch接受数据)
			return Promise.reject({
				statusCode: 0,
				errMsg: "【request】" + (httpData.info || httpData.msg),
				data: res.data
			});
		} else if (httpData.code == "1004") {
			if (loginPopupNum <= 0) {
				loginPopupNum++;
				$alert("您还未绑定手机号，请先绑定~", {
					type: 1,
					confirmText: "去绑定",
					cancelText: "再逛会",
				}, function (res) {
					loginPopupNum--;
					if (res.confirm) {
						router.push('/bindPhone');
					}

				});
			}
			// 返回错误的结果(catch接受数据)
			return Promise.reject({
				statusCode: 0,
				errMsg: "【request】" + (httpData.info || httpData.msg),
				data: res.data
			});
		} else { //其他错误提示   
			if (res.isPrompt) {
				prompt(httpData.info || httpData.msg);
			}
			// 返回错误的结果(catch接受数据)
			return Promise.reject({
				statusCode: 0,
				errMsg: "【request】" + (httpData.info || httpData.msg),
				data: res.data
			});
		}

		/*********以上只是模板(及共参考)，需要开发者根据各自的接口返回类型修改*********/

	} else if (res.response.status == "1000" || res.response.status == "1001" || res.response.status == 1000 || res.response.status == 401) {
		store.commit("emptyUserInfo");
		let content = '此时此刻需要您登录喔~';
		if (res.response.status == "1000") {
			content = '此时此刻需要您登录喔';
		}
		if (loginPopupNum <= 0) {
			loginPopupNum++;
			$alert(content, {
				type: 1,
				confirmText: "去登录",
				cancelText: "再逛会",
			}, function (res) {
				loginPopupNum--;
				if (res.confirm) {
					router.push('/login');
				}
			});
		}
		// #endif
		// 返回错误的结果(catch接受数据)
		return Promise.reject({
			statusCode: 0,
			errMsg: "【request】数据工厂验证不通过",
			data: res.data
		});
	} else {
		// 返回错误的结果(catch接受数据)
		return Promise.reject({
			statusCode: res.response.status,
			errMsg: "【request】数据工厂验证不通过",
			data: res.data
		});
	}

};
// 错误回调
$http.requestError = function (e) {
	// e.statusCode === 0 是参数效验错误抛出的
	if (e.statusCode === 0) {
		throw e;
	} else {
		console.log(e);
		prompt("网络错误，请检查一下网络");
	}
}
export default $http;
